export default Object.freeze({
    DEVELOPMENT: 'development',
    PRODUCTION:  'production',
    STAGING:     'staging',
    TEST:        'test',
});
